export class LinkedInternalTasksResultDto {
    internalTaskId: number;
    description: string;
}
